export enum SiteVisitLogStatus {
  Scheduled = 1,
  InProgress = 2,
  Completed = 3,
}
